import type { ReactNode } from "react";
import { FiAlertCircle, FiInbox } from "react-icons/fi";
import { AppButton } from "@/components/ui/primitives";

export interface TransactionsStateProps {
  /** empty: aún no hay movimientos · error: no se pudieron cargar (role="alert"). */
  kind: "empty" | "error";
  title: string;
  body: string;
  /** En error es «Reintentar» (primaria); en vacío, «Registrar movimiento». */
  primary: { label: string; onClick: () => void };
  secondary?: { label: string; onClick: () => void };
}

/** Estado vacío o de error de la lista de Movimientos, con una acción principal y opcionalmente una secundaria. */
export function TransactionsState({ kind, title, body, primary, secondary }: TransactionsStateProps) {
  const isError = kind === "error";
  const icon: ReactNode = isError ? <FiAlertCircle size={28} aria-hidden="true" /> : <FiInbox size={28} aria-hidden="true" />;

  return (
    <div
      role={isError ? "alert" : undefined}
      className="flex flex-col items-center rounded-[var(--ds-radius-lg)] bg-[var(--app-surface)] px-6 py-8 text-center text-[var(--app-text)]"
    >
      <span
        className={`mb-5 flex h-14 w-14 items-center justify-center rounded-full ${isError ? "bg-[var(--app-danger-soft)] text-[var(--app-danger)]" : "bg-[var(--ds-card-lilac)] text-[var(--ds-on-card)]"}`}
        aria-hidden="true"
      >
        {icon}
      </span>
      <h3 className="text-xl font-medium leading-7 tracking-[-0.02em]">{title}</h3>
      <p className="mt-2 max-w-[300px] text-sm leading-5 text-[var(--app-muted-text)]">{body}</p>
      <div className="mt-6 flex flex-col gap-3 sm:flex-row">
        <AppButton tone="primary" onClick={primary.onClick}>{primary.label}</AppButton>
        {secondary ? <AppButton tone="secondary" onClick={secondary.onClick}>{secondary.label}</AppButton> : null}
      </div>
    </div>
  );
}
